import { createStore } from "vuex";
import i18n from "../i18n";
import auth from './modules/auth';
import user from './modules/user';

// Função para obter o estado inicial do sidebar
const getInitialSidebarState = () => {
    // Se o menu style for horizontal, sempre esconde o sidebar
    const menuStyle = localStorage.getItem("menu_style");
    if (menuStyle === "horizontal") {
        return false;
    }
    
    // Em dispositivos móveis/tablets (< 992px), o sidebar deve começar fechado
    if (typeof window !== 'undefined' && window.innerWidth < 992) {
        // Verifica se há um estado salvo no localStorage
        const savedState = localStorage.getItem('sidebar_state_mobile');
        if (savedState !== null) {
            return savedState === 'true';
        }
        // Se não houver estado salvo, começa fechado em mobile/tablet
        return false;
    }
    // Em desktop, verifica se há estado salvo
    const savedState = localStorage.getItem('sidebar_state');
    if (savedState !== null) {
        return savedState === 'true';
    }
    // Padrão: aberto em desktop
    return true;
};

export default new createStore({
    state: {
        layout: "",
        is_show_sidebar: getInitialSidebarState(),
        sidebar_previous_state: true, // Estado anterior da sidebar antes de mudança automática
        sidebar_is_user_choice: true, // Indica se a mudança atual foi escolha do usuário (true) ou automática (false)
        is_show_search: false,
        is_dark_mode: false,
        dark_mode: "light",
        locale: null,
        menu_style: "vertical",
        layout_style: "full",
        isLoading: false,
        countryList: [
            { code: "zh", name: "Chinese" },
            { code: "da", name: "Danish" },
            { code: "en", name: "English" },
            { code: "fr", name: "French" },
            { code: "de", name: "German" },
            { code: "el", name: "Greek" },
            { code: "hu", name: "Hungarian" },
            { code: "it", name: "Italian" },
            { code: "ja", name: "Japanese" },
            { code: "pl", name: "Polish" },
            { code: "pt", name: "Português Brasileiro" },
            { code: "ru", name: "Russian" },
            { code: "es", name: "Spanish" },
            { code: "sv", name: "Swedish" },
            { code: "tr", name: "Turkish" },
        ],
    },
    mutations: {
        setLayout(state, payload) {
            state.layout = payload;
        },
        toggleSideBar(state, value) {
            // Se for escolha do usuário, marca como escolha do usuário
            state.sidebar_is_user_choice = true;
            state.is_show_sidebar = value;
            
            // Salva o estado no localStorage baseado no tamanho da tela
            if (typeof window !== 'undefined') {
                if (window.innerWidth < 992) {
                    // Em mobile/tablet, salva em uma chave específica
                    localStorage.setItem('sidebar_state_mobile', value.toString());
                } else {
                    // Em desktop, salva em outra chave
                    localStorage.setItem('sidebar_state', value.toString());
                }
            }
        },
        toggleSideBarAuto(state, value) {
            // Mudança automática (da página) - salva o estado anterior
            state.sidebar_previous_state = state.is_show_sidebar;
            state.sidebar_is_user_choice = false;
            state.is_show_sidebar = value;
        },
        restoreSidebarState(state) {
            // Restaura o estado anterior apenas se não foi escolha do usuário
            if (!state.sidebar_is_user_choice) {
                state.is_show_sidebar = state.sidebar_previous_state;
                state.sidebar_is_user_choice = true; // Reseta para permitir novas mudanças automáticas
            }
        },
        toggleSearch(state, value) {
            state.is_show_search = value;
        },
        toggleLocale(state, value) {
            value = value || "pt";
            i18n.global.locale.value = value;
            localStorage.setItem("i18n_locale", value);
            state.locale = value;
        },

        toggleDarkMode(state, value) {
            //light|dark|system
            value = value || "light";
            localStorage.setItem("dark_mode", value);
            state.dark_mode = value;
            if (value == "light") {
                state.is_dark_mode = false;
            } else if (value == "dark") {
                state.is_dark_mode = true;
            } else if (value == "system") {
                if (window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches) {
                    state.is_dark_mode = true;
                } else {
                    state.is_dark_mode = false;
                }
            }

            if (state.is_dark_mode) {
                document.querySelector("body").classList.add("dark");
            } else {
                document.querySelector("body").classList.remove("dark");
            }
        },

        toggleMenuStyle(state, value) {
            //horizontal|vertical|collapsible-vertical
            value = value || "";
            localStorage.setItem("menu_style", value);
            state.menu_style = value;
            if (value === "horizontal") {
                // Menu horizontal: sempre esconde o sidebar
                state.is_show_sidebar = false;
            } else if (!value || value === "vertical") {
                state.is_show_sidebar = true;
            } else if (value === "collapsible-vertical") {
                state.is_show_sidebar = false;
            }
        },

        toggleLayoutStyle(state, value) {
            //boxed-layout|large-boxed-layout|full
            value = value || "";
            localStorage.setItem("layout_style", value);
            state.layout_style = value;
        },
        setLoading(state, isLoading) {
            state.isLoading = isLoading;
        }
    },
    getters: {
        layout(state) {
            return state.layout;
        },
        isLoading(state) {
            return state.isLoading;
        }
    },
    actions: {},
    modules: {
        auth,
        user
    },
});
